import React from "react";
import { useLocation } from "react-router-dom";
import { getPageSerialInfo } from "../config/pageSerialRegistry";

const VARIANT_CLASS = {
  menu: "border-white/30 bg-black/15 text-white",
  plain: "border-slate-300 bg-slate-100 text-slate-800",
};

/**
 * Shows a fixed page serial (SL) for the current route — use on every screen.
 * @param {{ className?: string, variant?: "menu" | "plain" }} [props]
 */
export default function PageSerialBadge({ className = "", variant = "menu" }) {
  const { pathname } = useLocation();
  const info = getPageSerialInfo(pathname);
  const vc = VARIANT_CLASS[variant] || VARIANT_CLASS.menu;
  return (
    <span
      className={
        "inline-flex items-center rounded border px-1.5 py-0.5 font-mono text-[10px] font-semibold tabular-nums tracking-tight " +
        vc +
        " " +
        className
      }
      title={`${info.name} · Page SL`}
    >
      SL&nbsp;{info.padded}
    </span>
  );
}
